import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setNewFieldTypeHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.existing-fields-section.set-new-field-type-heading',
		defaultMessage: 'Create a new custom field',
		description: 'Header for section in dropdown menu to create a new field',
	},
	existingFieldSectionHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.existing-fields-section.existing-field-section-heading',
		defaultMessage: 'Map to an existing field',
		description: 'Header for section in dropdown menu to map to a reusable jira field',
	},
});
